import Vue from 'vue'
import Router from 'vue-router'
import EventsById from '@/components/EventsById'
import Events from '@/components/Events'
import Performances from '@/components/Performances'
import Availability from '@/components/Availability'
import SendMethods from '@/components/SendMethods'
import Discounts from '@/components/Discounts'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'eventsById',
      component: EventsById
    },
    {
      path: '/events',
      name: 'events',
      component: Events
    },
    {
      path: '/performances',
      name: 'performances',
      component: Performances
    },
    {
      path: '/availability',
      name: 'availability',
      component: Availability
    },
    {
      path: '/send-methods',
      name: 'sendMethods',
      component: SendMethods
    },
    {
      path: '/discounts',
      name: 'discounts',
      component: Discounts
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js